var twig = require("twig").twig;
var tpl = twig({"allowInlineIncludes":true,"data":[{"type":"raw","value":"<svg class=\"icon icon--music\" viewBox=\"0 0 24 24\" aria-hidden=\"true\">\n  <path fill=\"currentColor\" d=\"M12 3v10.55A4 4 0 1 0 14 17V7h4V3h-6z\"/>\n</svg>\n"}],"id":"resources/design-system/components/icons/icon-music.twig","rethrow":true});
module.exports = function(context) { return tpl.render(context); };
module.exports.id = "resources/design-system/components/icons/icon-music.twig";
module.exports.default = module.exports;
